import type { Mailbox } from '../../shared/api/types';
import { formatRemaining } from '../../shared/lib/format';

export interface StatusView {
  tone: 'active' | 'inactive';
  /** i18n key + опц. интерполяция времени. */
  key: 'status.active' | 'status.activeSoon' | 'status.inactive';
  time?: string;
}

/**
 * Эффективно активен ли ящик: статус active И окно активности (expiresAt) ещё не истекло.
 * Ящик без expiresAt (бессрочный) считается активным, пока статус active.
 */
export function isMailboxActive(m: Mailbox, nowMs: number = Date.now()): boolean {
  if (m.status !== 'active') return false;
  if (!m.expiresAt) return true;
  return new Date(m.expiresAt).getTime() > nowMs;
}

/** Карта статуса ящика в бейдж (Активен / Активен ещё ММ:СС / Неактивен). */
export function mailboxStatusView(m: Mailbox, nowMs: number = Date.now()): StatusView {
  if (!isMailboxActive(m, nowMs)) {
    return { tone: 'inactive', key: 'status.inactive' };
  }
  const remaining = formatRemaining(m.expiresAt, nowMs);
  if (remaining) {
    return { tone: 'active', key: 'status.activeSoon', time: remaining };
  }
  return { tone: 'active', key: 'status.active' };
}

export const ALIAS_RE = /^[a-z0-9.-]{3,64}$/i;
